import React, { useState, useContext } from 'react'
import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Divider,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	TextField,
} from '@mui/material'
import { AccountBalance, Person, Group } from '@mui/icons-material'
import { MonopolyContext } from '../../../contexts/MonopolyContext'
import { ref, runTransaction } from 'firebase/database'

const Pay = ({ users, myUserId, roomCode, setDrawer, enqueueSnackbar }) => {
	const { db, M } = useContext(MonopolyContext),
		[to, setTo] = useState(false),
		me = users.find(user => user.userId === myUserId),
		myBalance = parseInt(me.balance ?? 0),
		[user, setUser] = useState(false),
		[loading, setLoading] = useState(false),
		[error, setError] = useState(false),
		[payAmount, setPayAmount] = useState(100),
		payTo = to => {
			if (to.substr(0, 5) === 'user:') {
				const userId = to.substr(5)
				setUser(users.find(user => user.userId === userId))
			}
			setTo(to)
		},
		payToUser = (post, userId, amount, time) => {
			if (userId !== ':bank') {
				if (userId.substr(0, 5) === 'user:') {
					userId = userId.substr(5)
				}

				// update other user
				if (!post.users[userId].balance) {
					post.users[userId].balance = 0
				}
				post.users[userId].balance =
					parseInt(post.users[userId].balance) + amount
				if (!post.users[userId].history) {
					post.users[userId].history = []
				}
				post.users[userId].history.push({
					time,
					amount,
					action: 'receive',
					from: myUserId,
				})
			}

			// update my user
			if (!post.users[myUserId].balance) {
				post.users[myUserId].balance = 0
			}
			post.users[myUserId].balance -= amount
			if (!post.users[myUserId].history) {
				post.users[myUserId].history = []
			}
			post.users[myUserId].history.push({
				time,
				amount,
				action: 'pay',
				to: to === ':bank' ? 'bank' : userId,
			})
		},
		pay = _ => {
			setLoading(true)
			runTransaction(ref(db, `lobbies/${roomCode}`), post => {
				if (post) {
					const amount = +payAmount,
						time = new Date().valueOf()
					if (!post.history) {
						post.history = []
					}
					if (to === ':all') {
						post.history.push({
							time,
							amount,
							action: 'sentToEveryone',
							user: myUserId,
						})
						users.map(
							user =>
								user.userId !== myUserId &&
								payToUser(post, user.userId, amount, time)
						)
					} else {
						if (to === ':bank') {
							post.history.push({
								time,
								amount,
								action: 'sentToBank',
								user: myUserId,
							})
						} else {
							post.history.push({
								time,
								amount,
								action: 'sentToUser',
								user: myUserId,
								to: to,
							})
						}
						payToUser(post, to, amount, time)
					}

					setDrawer(false)
				}
				setLoading(false)
				return post
			})
		}

	return (
		<>
			<List>
				<ListItem button='true' key=':bank' onClick={_ => payTo(':bank')}>
					<ListItemIcon>
						<AccountBalance />
					</ListItemIcon>
					<ListItemText primary='Bank' />
				</ListItem>
			</List>
			{users.length > 1 && (
				<>
					<Divider />
					<List>
						{users.map(user =>
							user.userId === myUserId ? null : (
								<ListItem
									button='true'
									key={`user:${user.userId}`}
									onClick={_ => payTo(`user:${user.userId}`)}>
									<ListItemIcon>
										<Person />
									</ListItemIcon>
									<ListItemText>
										{user.name} ({user.balance ?? 0} <M />)
									</ListItemText>
								</ListItem>
							)
						)}
					</List>
					<Divider />
					<List>
						<ListItem button='true' key=':all' onClick={_ => payTo(':all')}>
							<ListItemIcon>
								<Group />
							</ListItemIcon>
							<ListItemText primary='To Everyone' />
						</ListItem>
					</List>
				</>
			)}
			<Dialog
				open={!!to}
				onClose={_ => setTo(false)}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'>
				<DialogTitle id='alert-dialog-title'>
					Pay <M /> to{' '}
					{(to === ':bank' && 'the Bank') ||
						(to === ':all' && 'Everyone') ||
						user.name}
				</DialogTitle>
				<DialogContent>
					<TextField
						InputProps={{ style: { letterSpacing: '.1em' } }}
						autoFocus
						required
						variant='standard'
						label='Amount'
						error={!!error}
						helperText={
							error
								? error
								: `How much you have to pay${
										to === ':all' ? ' per player' : ''
								  }`
						}
						onChange={e => {
							let value = e.target.value
							value = value.replace(/\D/, '').substr(0, 6)
							if (value > myBalance) {
								setError(`This is more than you have.`)
							} else if (value <= 0) {
								setError(`Please type in an amount.`)
							} else {
								setError(false)
							}
							setPayAmount(value)
						}}
						pattern='\d+'
						value={payAmount}
						maxLength='6'
						name='amount'
						id='amount'
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={_ => setTo(false)}>Cancel</Button>
					<Button
						disabled={!!error || loading}
						color='red'
						variant='contained'
						onClick={pay}>
						Pay {payAmount * (to === ':all' ? users.length - 1 : 1)} <M />{' '}
						{to === ':all' ? ' (in total)' : ''}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

export default Pay
